<template>
<div>
  <v-toolbar class="pr-2 elevation-0 transparent">
    <v-btn :to="'/content/' + contentData.url + '/' + sectionData.url" color="error" icon flat exact>
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title class="ml-0 headline">Create Task</v-toolbar-title>
  </v-toolbar>

  <v-layout row wrap justify-center>
    <v-flex class="px-3" xs12>
      <r-crumbs></r-crumbs>
    </v-flex>
    <v-flex xs12 md10>
      <v-layout v-if="loading || changing" row justify-center>
        <v-flex class="text-xs-center py-5 my-5" xs12>
          <v-progress-circular color="accent" indeterminate></v-progress-circular>
        </v-flex>
      </v-layout>
      <v-layout v-else row wrap justify-center>
        <v-flex class="py-3 text-xs-center" xs12 sm10 md7>
          <v-menu max-height="300px" full-width offset-y>
            <v-btn slot="activator" color="white" class="my-0 elevation-0" block large>
              <span><b>{{newTask.type}}</b></span>
              <v-icon class="ml-1" right>arrow_drop_down</v-icon>
            </v-btn>
            <v-list>
              <template v-for="type in ['Reading', 'Lecture', 'Practice', 'NCLEX', 'Linking']">
                <v-list-tile v-if="newTask.type == type" :key="type">
                  <v-list-tile-title class="grey--text text--lighten-1">
                    <b>{{type}}</b>
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-else :key="type" @click="changeType(type)">
                  <v-list-tile-title>
                    <b>{{type}}</b>
                  </v-list-tile-title>
                </v-list-tile>
              </template>
            </v-list>
          </v-menu>
        </v-flex>
        <v-flex xs12></v-flex>
        <v-flex v-if="newTask.type == 'Task Type'" class="px-2 pb-2 py-5 my-5" xs12 md7>
          <div class="text-xs-center display-3 grey--text text--lighten-1">Choose A Type</div>
        </v-flex>
        <template v-if="newTask.type == 'Reading' || newTask.type == 'Lecture'">
          <v-flex class="pb-3" xs12 sm10 md6>
            <v-text-field
              label="Name"
              v-model.trim="newTask.name"
              hide-details
            ></v-text-field>
          </v-flex>
        </template>
        <template v-if="newTask.type == 'Practice' || newTask.type == 'NCLEX'">
          <v-flex class="pb-3 px-1" xs12 sm10 md6>
            <v-text-field
              label="Name"
              v-model.trim="newTask.name"
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex class="pb-3 px-1" xs12 sm10 md6>
            <v-select
              label="Tags"
              v-model="newTask.tags"
              :items="getTags()"
              :multiple="newTask.type == 'Practice'"
              :chips="newTask.type == 'Practice'"
              hide-details
            ></v-select>
          </v-flex>
          <v-flex v-if="newTask.type == 'Practice'" class="pb-3 px-1" xs6 md3>
            <v-text-field
              label="# of Questions"
              v-model.trim="newTask.numOfQuestions"
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex v-if="newTask.type == 'Practice'" class="pb-3 px-1" xs6 md3>
            <v-text-field
              label="Percent Easy (Optional)"
              v-model.trim="newTask.percentEasy"
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex v-if="newTask.type == 'NCLEX'" class="pb-3 px-1" xs6 md3>
            <v-text-field
              label="Min Questions"
              v-model.trim="newTask.minQuestions"
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex v-if="newTask.type == 'NCLEX'" class="pb-3 px-1" xs6 md3>
            <v-text-field
              label="Max Questions"
              v-model.trim="newTask.maxQuestions"
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex class="pb-3 px-1" xs6 md3>
            <v-text-field
              label="Time Allowed (Mins)"
              v-model.trim="newTask.timeAllowed"
              :disabled="newTask.type == ''"
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex class="pb-3 px-1" xs6 md3>
            <v-text-field
              label="Attempts"
              v-model.trim="newTask.attempts"
              :disabled="newTask.type == ''"
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex class="pb-3 px-1" xs6 md3>
            <v-text-field
              label="Pass Grade"
              v-model.trim="newTask.passGrade"
              :disabled="newTask.type == ''"
              hide-details
            ></v-text-field>
          </v-flex>
        </template>
        <template v-if="newTask.type == 'Linking'">
          <v-flex class="pb-3" xs12 sm10 md6>
            <v-text-field
              label="Name"
              v-model.trim="newTask.name"
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex class="pb-3 px-1" xs12 sm10 md6>
            <v-select
              label="Choose Content"
              @blur="sectionNames = getSections(), chosenSection = '', chosenTask = ''"
              v-model="chosenContent"
              :items="contentNames"
              hide-details
            ></v-select>
          </v-flex>
          <v-flex class="pb-3 px-1" xs12 sm10 md6>
            <v-select
              label="Choose Sections"
              @blur="taskNames = getTasks(), chosenTask = ''"
              v-model="chosenSection"
              :items="sectionNames"
              hide-details
            ></v-select>
          </v-flex>
          <v-flex class="pb-3 px-1" xs12 sm10 md6>
            <v-select
              label="Choose Task"
              v-model="chosenTask"
              :items="taskNames"
              hide-details
            ></v-select>
          </v-flex>
        </template>
        <template v-if="newTask.type != 'Task Type'">
          <v-flex class="py-3 text-xs-center" xs12>
            <v-btn
              @click.native="canCreate"
              color="success"
              :loading="creating"
              :disabled="creating"
              depressed
              large
            ><b>Create</b></v-btn>
            <v-btn
              @click.native="popup.type = 'Resetting', popup.show = true"
              color="error"
              flat
              large
            ><b>Reset</b></v-btn>
          </v-flex>
        </template>
      </v-layout>
    </v-flex>
  </v-layout>

  <r-task-popup
    :popup="popup"
    :task-data="newTask"
  ></r-task-popup>
</div>
</template>

<script>
import Crumbs from '../general/Crumbs.vue'
import TaskPopup from './TaskPopup.vue'
import {contentEvent} from '../../main'
export default {
  components: {
    rTaskPopup: TaskPopup,
    rCrumbs: Crumbs
  },
  data: () => ({
    loading: false,
    changing: false,
    creating: false,
    content: [],
    contentNames: [],
    sections: [],
    sectionNames: [],
    tasks: [],
    taskNames: [],
    contentData: {},
    sectionData: {},
    newTask: {},
    chosenContent: '',
    chosenSection: '',
    chosenTask: '',
    popup: {
      show: false,
      type: ''
    }
  }),
  beforeMount () {
    contentEvent.$off()
    this.load()
    contentEvent.$on('reset', () => {
      this.resetNewTask()
    })
    contentEvent.$on('createTask', () => {
      this.createTask()
    })
  },
  methods: {
    load () {
      this.loading = true
      this.content = this.$store.getters.content
      for (let c of this.content) {
        this.contentNames.push(c.name)
      }
      this.contentData = this.$store.getters.contentByUrl(this.$route.params.contentUrl)
      this.sections = this.$store.getters.sectionByContent(this.contentData.key)
      for (let s of this.sections) {
        if (s.url === this.$route.params.sectionUrl) this.sectionData = s
      }
      this.tasks = this.$store.getters.taskBySection(this.sectionData.key)
      this.resetNewTask()
      this.loading = false
    },
    resetNewTask () {
      this.newTask = {type: 'Task Type', name: '', url: ''}
    },
    changeType (type) {
      this.changing = true
      setTimeout(() => {
        if (type === 'Linking') this.newTask = {type: type, name: '', url: '', sectionKey: this.sectionData.key, linkedTaskKey: ''}
        else if (type === 'Reading' || type === 'Lecture') this.newTask = {type: type, name: '', url: '', sectionKey: this.sectionData.key}
        else {
          this.newTask = {
            type: type,
            name: '',
            url: '',
            sectionKey: this.sectionData.key,
            tags: [],
            numOfQuestions: type === 'Practice' ? '' : null,
            percentEasy: type === 'Practice' ? '' : null,
            minQuestions: type === 'NCLEX' ? '' : null,
            maxQuestions: type === 'NCLEX' ? '' : null,
            timeAllowed: '',
            attempts: '',
            passGrade: ''
          }
        }
        this.changing = false
      }, 250)
    },
    getTags () {
      if (this.newTask.type === 'Practice') return this.$store.getters.tags
      else return ['RN', 'PN']
    },
    getSections () {
      let names = []
      if (this.chosenContent.length > 0) {
        for (let c of this.content) {
          if (c.name === this.chosenContent) {
            for (let s of this.$store.getters.sectionByContent(c.key)) {
              names.push(s.name)
            }
          }
        }
      }
      let collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'})
      names.sort(collator.compare)
      return names
    },
    getTasks () {
      let names = []
      if (this.chosenContent.length > 0) {
        for (let c of this.content) {
          if (c.name === this.chosenContent) this.sections = this.$store.getters.sectionByContent(c.key)
        }
        for (let s of this.sections) {
          if (s.name === this.chosenSection) this.tasks = this.$store.getters.taskBySection(s.key)
        }
        for (let t of this.tasks) {
          if (t.type !== 'Linking') names.push(t.name)
        }
      }
      let collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'})
      names.sort(collator.compare)
      return names
    },
    canCreate () {
      const digit = this.$store.getters.reg.digit
      const appMsg = {
        type: 'error',
        msg: ''
      }
      if (this.newTask.name === '') {
        appMsg.msg = 'Please enter a name for the section'
        this.$store.dispatch('showAppMsg', appMsg)
        return
      }
      if (this.newTask.name.toLowerCase() === 'create') {
        appMsg.msg = 'Please use a different name; that name is reserved.'
        this.$store.dispatch('showAppMsg', appMsg)
        return
      }
      for (let t of this.tasks) {
        if (this.newTask.name.toLowerCase() === t.name.toLowerCase()) {
          appMsg.msg = 'That task name already exists in this section'
          this.$store.dispatch('showAppMsg', appMsg)
          return
        }
      }
      if (this.newTask.type === 'Practice' || this.newTask.type === 'NCLEX') {
        if (this.newTask.tags.length === 0) {
          appMsg.msg = 'Please choose at least one tag for this task'
          this.$store.dispatch('showAppMsg', appMsg)
          return
        }
        if (this.newTask.timeAllowed === '') {
          appMsg.msg = 'Please enter only numbers greater than 0 for time allowed'
          this.$store.dispatch('showAppMsg', appMsg)
          return
        } else if (!digit.test(this.newTask.timeAllowed)) {
          appMsg.msg = 'Please enter only numbers greater than 0 for time allowed'
          this.$store.dispatch('showAppMsg', appMsg)
          return
        } else if (parseInt(this.newTask.timeAllowed) <= 0) {
          appMsg.msg = 'Please enter only numbers greater than 0 for time allowed'
          this.$store.dispatch('showAppMsg', appMsg)
          return
        }
        if (this.newTask.attempts !== '') {
          if (!digit.test(this.newTask.attempts)) {
            appMsg.msg = 'Please enter only numbers greater than 0 for attempts'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          } else if (parseInt(this.newTask.attempts) <= 0) {
            appMsg.msg = 'Please enter only numbers greater than 0 for attempts'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          }
        }
        if (this.newTask.passGrade !== '') {
          if (!digit.test(this.newTask.passGrade)) {
            appMsg.msg = 'Please enter only numbers greater than 0 for pass grade'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          } else if (parseInt(this.newTask.passGrade) <= 0) {
            appMsg.msg = 'Please enter only numbers greater than 0 for pass grade'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          }
        }
        if (this.newTask.type === 'Practice') {
          if (this.newTask.numOfQuestions === '') {
            appMsg.msg = 'Please enter only numbers greater than 0 for number of questions'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          } else if (!digit.test(this.newTask.numOfQuestions)) {
            appMsg.msg = 'Please enter only numbers greater than 0 for number of questions'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          } else if (parseInt(this.newTask.numOfQuestions) <= 0) {
            appMsg.msg = 'Please enter only numbers greater than 0 for number of questions'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          }
          if (this.newTask.percentEasy !== '') {
            if (!digit.test(this.newTask.percentEasy)) {
              appMsg.msg = 'Please enter only numbers greater than 0 for percent easy'
              this.$store.dispatch('showAppMsg', appMsg)
              return
            } else if (parseInt(this.newTask.percentEasy) <= 0) {
              appMsg.msg = 'Please enter only numbers greater than 0 for percent easy'
              this.$store.dispatch('showAppMsg', appMsg)
              return
            }
          }
        } else {
          if (this.newTask.minQuestions === '') {
            appMsg.msg = 'Please enter only numbers greater than 0 for min number of questions'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          } else if (!digit.test(this.newTask.minQuestions)) {
            appMsg.msg = 'Please enter only numbers greater than 0 for min number of questions'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          } else if (parseInt(this.newTask.minQuestions) <= 0) {
            appMsg.msg = 'Please enter only numbers greater than 0 for min number of questions'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          }
          if (this.newTask.maxQuestions === '') {
            appMsg.msg = 'Please enter only numbers greater than 0 for max number of questions'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          } else if (!digit.test(this.newTask.maxQuestions)) {
            appMsg.msg = 'Please enter only numbers greater than 0 for max number of questions'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          } else if (parseInt(this.newTask.maxQuestions) <= 0) {
            appMsg.msg = 'Please enter only numbers greater than 0 for max number of questions'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          }
          if (parseInt(this.newTask.minQuestions) >= parseInt(this.newTask.maxQuestions)) {
            appMsg.msg = 'Minimun number of questions cannot be larger than maximum number of questions'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          }
        }
      } else if (this.newTask.type === 'Linking') {
        if (this.chosenContent === '' || this.chosenSection === '' || this.chosenTask === '') {
          appMsg.msg = 'Please choose a task to link to this task'
          this.$store.dispatch('showAppMsg', appMsg)
          return
        }
      }
      if (this.newTask.type === 'NCLEX') contentEvent.$emit('nclexPopup')
      if (this.newTask.type === 'Linking') this.newTask.linkedTaskKey = this.getLinkedTaskKey()
      this.popup = {
        show: true,
        type: 'Creating Task'
      }
    },
    createTask () {
      this.creating = true
      this.newTask.url = this.$store.getters.formatUrl(this.newTask.name)
      this.formatTask()
      this.$store.dispatch('createTask', this.newTask).then(() => {
        const appMsg = {
          type: 'success',
          msg: this.newTask.name + ' created!'
        }
        this.$store.dispatch('showAppMsg', appMsg)
        this.$router.push('/content/' + this.contentData.url + '/' + this.sectionData.url + '/' + this.newTask.url)
        this.creating = false
      }).catch(err => {
        const appMsg = {
          type: 'error',
          msg: err.message
        }
        this.creating = false
        this.$store.dispatch('showAppMsg', appMsg)
      })
    },
    getLinkedTaskKey () {
      let linkedTaskKey = ''
      for (let c of this.content) {
        if (c.name === this.chosenContent) this.sections = this.$store.getters.sectionByContent(c.key)
      }
      for (let s of this.sections) {
        if (s.name === this.chosenSection) this.tasks = this.$store.getters.taskBySection(s.key)
      }
      for (let t of this.tasks) {
        if (t.name === this.chosenTask) linkedTaskKey = t.key
      }
      return linkedTaskKey
    },
    formatTask () {
      if (this.newTask.type === 'Practice' || this.newTask.type === 'NCLEX') {
        if (this.newTask.type === 'Practice') this.newTask.percentEasy = this.newTask.percentEasy === '' ? null : this.newTask.percentEasy
        this.newTask.timeAllowed = this.newTask.timeAllowed === '' ? null : this.newTask.timeAllowed
        this.newTask.attempts = this.newTask.attempts === '' ? null : this.newTask.attempts
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/content/CreateTask.vue